import { Component } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-how-to-reach',
  standalone: false,
  templateUrl: './how-to-reach.component.html',
  styleUrl: './how-to-reach.component.css'
})
export class HowToReachComponent {
  constructor(private sidebarService: SidebarService) { }

  ngOnInit() {
    this.sidebarService.setTitle('How to Reach');
  }

  ngOnDestroy() {
    this.sidebarService.clearTitle();
  }
}
